/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Male_Bald_Skunk_BorrowInputs */

const fr_male_bald_skunk_borrow = /** @type {(inputs: Male_Bald_Skunk_BorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il n'existe aucune section pour ce cours. Merci d'en ajouter une`)
};

/**

* @param {Male_Bald_Skunk_BorrowInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const male_bald_skunk_borrow = /** @type {((inputs?: Male_Bald_Skunk_BorrowInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Male_Bald_Skunk_BorrowInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_male_bald_skunk_borrow(inputs)
});